import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { webauthnApi } from "../api/webauthnApi";
import { REGISTRATION_POLL_MS } from "../config";
import { usePreauthExpiryGuard } from "../usePreauthExpiryGuard";

/**
 * Polls the enrollment request status while the user is on the pending screen.
 * Backs off via a fixed interval (no tight polling). Stops once terminal.
 */
export function useRegistrationStatus(enabled = true) {
  const guardPreauth = usePreauthExpiryGuard();
  const ticket = useSelector((s) => s.auth.webauthn?.preauth_ticket);
  const requestId = useSelector((s) => s.auth.webauthn?.request_id);

  return useQuery(
    ["webauthn", "registration-status", requestId],
    () => webauthnApi.registerStatus(ticket, requestId),
    {
      enabled,
      refetchInterval: (data) => {
        const terminal = ["approved", "rejected", "completed"];
        if (data && terminal.includes(data.status)) return false;
        return REGISTRATION_POLL_MS;
      },
      refetchOnWindowFocus: true,
      // Ticket can expire mid-wait → bounce to login instead of erroring on.
      onError: (error) => guardPreauth(error),
    }
  );
}
